"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmbedPlayer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var EmbedPlayer = exports.EmbedPlayer = function EmbedPlayer(_ref) {
  var embedCode = _ref.embedCode;
  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: embedCode
    }
  }));
};
EmbedPlayer.propTypes = {
  embedCode: _propTypes["default"].string
};